import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import classNames from 'classnames';
import BgSlide from './BgSlide';
import Immutable from 'immutable';

const pickApony = (id) =>
  Immutable.fromJS([
    '/img/My-Little-Pony.jpg',
    '/img/Gala-outfits-my-little-pony-friendship-is-magic-25312887-1280-720.jpg',
    '/img/mlp_crystalquest.jpg',
    '/img/Fluttershy_and_Ponytones_--got_the_music--_2_S4E14.png',
    '/img/my_little_pony_friendship_is_magic1.png',
  ]).get(id - 1);

class BgSlider extends React.Component {

  constructor(props) {
    super(props);
    this.state = { pos: 0 };
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this)
      .addEventListener('transitionend', this.props.actions.sliderUnsetLock);
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.onResize.bind(this));
    }
    this.componentDidMountUniversal();
  }

  componentWillReceiveProps(props) {
    this.setState({ pos: this.getPosition(props) });
  }

  componentWillUnmount() {
    ReactDOM.findDOMNode(this)
      .removeEventListener('transitionend', this.props.actions.sliderUnsetLock);
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize.bind(this));
    }
  }

  onResize() {
    this.setState({ pos: this.getPosition(this.props) });
  }

  getPosition(props) {
    return (typeof window === 'undefined') ? 0 :
      0 - (window.innerHeight * props.currentIndex);
  }

  componentDidMountUniversal() {
    this.onResize();
    if (this.props.currentIndex === 0) this.props.actions.sliderUnsetLock();
  }

  render() {
    const posStyle = {
      WebkitTransform: `translate3d(0px, ${this.state.pos}px, 0)`,
      MozTransform: `translate3d(0px, ${this.state.pos}px, 0)`,
      msTransform: `translate3d(0px, ${this.state.pos}px, 0)`,
      transform: `translate3d(0px, ${this.state.pos}px, 0)`,
    };
    const { locked, items, lang, sliderBtn, nextUri, ponies, showSection } = this.props;
    return (
      <CSSTransitionGroup
        transitionName="example"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        <div
          key="sliderBox"
          style={{ height: '100%', position: 'fixed', width: '100%', zIndex: 1 }}
        >
          <div
            key="slider"
            style={posStyle}
            className={classNames('scroll-main', { scrolling: !locked })}
          >
            {items.map((slide, i) =>
              <BgSlide
                key={i}
                item={ponies ? slide.set('background', pickApony(i)) : slide}
                lang={lang}
                locked={locked || i === items.size - 1} // do not show next button on last slide
                goNext={() => sliderBtn(nextUri)}
                showSection={showSection}
              />)}
          </div>
        </div>
      </CSSTransitionGroup>
    );
  }
}

BgSlider.propTypes = {
  locked: PropTypes.bool.isRequired,
  ponies: PropTypes.bool.isRequired,
  items: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  currentIndex: PropTypes.number.isRequired,
  actions: PropTypes.object.isRequired,
  sliderBtn: PropTypes.func.isRequired,
  showSection: PropTypes.func.isRequired,
  nextUri: PropTypes.string.isRequired,
};

export default BgSlider;



// WEBPACK FOOTER //
// ./common/components/BgSlider.js